import { useCallback, useEffect, useState } from "react";
import { BasicTable, MASK_MONEY } from "../theme/Component/BasicTable";
import { CardTaps } from "../theme/Component/CardTaps";
import AutoChart from "../../core/graph/AutoChart";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { _single } from "../../core/services/dataBean/EntityCatalog";

interface Props {
    lista: any;
    head: any;
}
export const AdquisitionPlanProject = ({ lista, head }: Props) => {

    const [bean, setBean] = useState<any>({});
    const [listaReport, setListaReport] = useState<any>([]);
    const [indexTap, setIndexTap] = useState(0);
    const [indice, setIndice] = useState<any>(1);
    const [variable, setVariable] = useState<string>('PFValue');
    const [key, setkey] = useState<number>(_single.getRandomInt());

    const variables = [
        { id: 'PIValue', name: "Presupuesto Inicial (PI)" },
        { id: 'PFTotal', name: "Presupuesto Final (PF)" },
        // { id: 'EstimatedValue', name: "Valor Estimado" },
        { id: 'RPValue', name: "Registro Presupuestal (RP)" },
        { id: 'CDPValue', name: "Certificado disponibilidad presupuestal (CDP)" },
        // { id: 'IADValue', name: "Registro Ingresos (IAD)" },
    ]


    useEffect(() => {
        setListaReport(lista);
    }, [lista, head])



    let taps = [
        { id: 0, name: 'Reporte', disable: false },
        { id: 1, name: 'Grafico', disable: lista.length === 0 }
    ];

    const proyectarValores = () => {
        if (indice) {
            let temp = [...listaReport];
            temp.forEach(element => {
                element.DataBeanProperties.PYValue = calcularValor(element.DataBeanProperties[variable], indice);
            });

            setListaReport(temp);
            toast.success("Valores Actualizados.");
            setkey(_single.getRandomInt());
        }
    }

    const calcularValor = (val1: any, val2: any): number => {
        const v1 = isNaN(parseFloat(val1)) ? 0 : parseFloat(val1);
        const v2 = isNaN(parseFloat(val2)) ? 0 : parseFloat(val2);
        return v1 * (1 + v2 / 100);
    };



    return (
        <div className="row">
            <div className="col" >
                <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4">
                                    <label>Tipo Variable</label>
                                    <select name="var" className="form-select" value={variable} onChange={(e) => { setVariable(e.target.value) }}>
                                        {variables.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label>Indice de calculo %</label>
                                    <input type="number" name="indice" className="form-control" value={indice} onChange={(e) => { setIndice(e.target.value) }} />
                                </div>
                                <div className="col-md-4 mt-4">
                                    <BasicButton icon="" eventClick={proyectarValores} >Proyectar</BasicButton>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {indexTap == 0 ?
                                <div className="row">
                                    <div className="col-md-12">
                                        <BasicTable head={head} body={listaReport} rowSet={setBean}></BasicTable>
                                    </div>
                                </div>
                                :
                                <AutoChart data={listaReport} head={head} useIndexAsXLabel={true}
                                    xOptions={['BudgetIDName', 'BudgetResourceName', 'BudgetSourceName', 'BudgetTypeName']}
                                    yOptions={['PIValue', 'PFTotal', 'CDPValue', 'RPValue', 'CCValue','LeftValue','RCDPValue','RRPValue']} />
                            }
                        </div>
                    </div>
                </CardTaps>
            </div>
        </div>
    )
}